import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { TAB_BACK_DATA } from '@blade-sxp/screen/constants/index';
import { SENSECODE } from '@blade/common/constants/code';
import { dashboardConfig } from '@blade-sxp/screen/api/index';
import store from '@blade-sxp/screen/store/index';
import { getIconVisibleDistance } from '@blade-sxp/screen/api/build-information';
export const MAP_ITEMS = [
    {
        name: 'CAM',
        path: '/screen/crowdInsightCam',
        code: SENSECODE.CROWD_CAM,
        cardId: SENSECODE.CROWD_CAM,
    },
    {
        name: 'CL',
        path: '/screen/crowdInsightCl',
        code: SENSECODE.CROWD_CL,
        cardId: SENSECODE.CROWD_CL,
    },
    {
        name: 'VA',
        path: '/screen/crowdInsightBackEndVa',
        code: SENSECODE.CROWD_VA,
        cardId: SENSECODE.CROWD_VA,
    },
    {
        name: 'QUEUE',
        path: '/screen/queueInsight',
        code: SENSECODE.QUEUE_INSIGHT,
        cardId: SENSECODE.QUEUE_INSIGHT,
    },
    {
        name: 'ALERT',
        path: '/screen/alertMap',
        code: SENSECODE.ALERT_MAP,
        cardId: SENSECODE.ALERT_MAP,
    },
    {
        name: 'UV',
        path: '/screen/crowdInsightUv',
        code: SENSECODE.CROWD_UV,
        cardId: SENSECODE.CROWD_UV,
    },
    {
        name: 'PI',
        path: '/screen/parkingInsight',
        code: SENSECODE.PARKING_INSIGHT,
        cardId: SENSECODE.PARKING_INSIGHT,
    },
    {
        name: 'PI',
        path: '/screen/buildInformation',
        code: SENSECODE.BUILDING_INFO,
        cardId: SENSECODE.BUILDING_INFO,
    },
];
let default_1 = class extends Vue {
    tabData = TAB_BACK_DATA;
    mapItems = [];
    activeIndex = -1;
    snapTime = '';
    $route;
    $router;
    get path() {
        return this.$route.path;
    }
    get ueMap() {
        return store.ueMap;
    }
    mounted() {
        this.setDashboard();
        this.getIconVisibleDistance();
    }
    getActiveName() {
        this.activeIndex = this.mapItems.findIndex((item) => item.path === this.path);
    }
    tabClick(item, index) {
        if (item.path === this.path)
            return;
        console.log('====item', item);
        this.activeIndex = index;
        store.updateZoneId(store.rootId);
        this.$router.push({ path: item.path });
        this.ueMap.resetSection();
        store.updateCurrentBuildId('');
        store.updateIsShow(false);
    }
    async setDashboard() {
        const { MAP: mapData = [] } = (await dashboardConfig());
        this.mapItems = mapData.map((item) => {
            const curr = MAP_ITEMS.find((map) => map.cardId === item.cardId);
            return {
                ...item,
                name: item.cardName,
                path: curr?.path,
            };
        });
        this.getActiveName();
    }
    // 获取后端标签可视距离值
    async getIconVisibleDistance() {
        const res = await getIconVisibleDistance();
        store.updateVisibleDistance(res);
    }
};
default_1 = __decorate([
    Component({
        name: 'screenHead',
        components: {},
        i18n: {
            messages: {
                en: {
                    buildInformation: 'Building Information',
                    attendance: 'Attendance',
                },
                zh: {
                    buildInformation: '建筑信息',
                    attendance: '区域人群',
                },
            },
        },
    })
], default_1);
export default default_1;
